import { faMoneyBillTransfer, faVault } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import cn from 'classnames';
import { useSearchParamsUpdater } from 'hooks/useSearchParamsUpdater';
import { useForm } from 'hooks/useForm';
import { createTransaction, createTransactionSilent } from '@redux/features/transactionsSlice';
import { getCashboxes } from '@redux/features/cashboxesSlice';
import { isNotToday } from 'helpers/isNotToday';
import { getCashTransitSchema } from 'constants/formValidationSchemas/cashTransitSchema';
import { MoneyAmount } from 'components/MoneyAmount';
import { TabSelector } from 'components/TabSelector';
import { Button } from 'components/Button';
import { Input } from 'components/Input';
import styles from 'pages/CashRegister/CashRegister.scss';

const typeOptions = { transfer_out: 'Передати', transfer_in: 'Видати' };

export const Safe = ({
  safe,
  safeBalance,
  cashRegister,
  cashRegisterBalance,
  locationID,
  onTransactionCreated,
  showSafeForm,
}) => {
  const [resetCounter, setResetCounter] = useState(0);
  const query = useSearchParamsUpdater();
  const dispatch = useDispatch();

  const { values, errors, touched, handleChange, setFieldValue, handleBlur, handleSubmit, isSubmitting, resetForm } =
    useForm({
      initialValues: { amount: '', type: 'transfer_out' },
      validationSchema: getCashTransitSchema(cashRegisterBalance || 0, safeBalance || 0),
      onSubmit: async (values) => {
        const date = query.getParam('date');
        const firstType = values.type;
        const secondType = firstType === 'transfer_in' ? 'transfer_out' : 'transfer_in';

        const result = await dispatch(
          createTransaction({
            ...values,
            methodID: cashRegister.methods.find((m) => m.value === 'cash')?.id,
            relatedCashboxID: safe.id,
            locationID,
            ...(isNotToday(date) && { date }),
          })
        );

        await createTransactionSilent({
          ...values,
          type: secondType,
          cashboxID: safe.id,
          relatedCashboxID: cashRegister.id,
          methodID: safe.methods.find((m) => m.value === 'cash')?.id,
          locationID,
          ...(isNotToday(date) && { date }),
        });

        if (result.meta.requestStatus === 'fulfilled') {
          await dispatch(getCashboxes(locationID));
          setResetCounter((prev) => prev + 1);
          resetForm();

          const newTransactionId = result.payload?.id;
          setTimeout(() => {
            onTransactionCreated?.(newTransactionId);
          }, 100);
        }
      },
    });

  const handleTypeChange = (index) => {
    const typeKey = Object.keys(typeOptions)[index];
    setFieldValue('type', typeKey);
  };

  return (
    <div className={cn(styles.section, styles.safe, { [styles.active]: showSafeForm })}>
      <div className={styles.header}>
        <h2>
          <FontAwesomeIcon icon={faVault} /> Сейф
        </h2>
        <div className={styles.balance}>
          <span className={styles.label}>Баланс:</span>
          <MoneyAmount className={styles.value} value={safeBalance || 0} />
        </div>
      </div>
      <TabSelector
        className={styles.typeSelector}
        tabs={Object.values(typeOptions)}
        onTabChange={handleTypeChange}
        resetTrigger={resetCounter}
      />
      <form onSubmit={handleSubmit} className={styles.safeForm}>
        <Input
          className={styles.inputField}
          type='number'
          name='amount'
          id='safeDeposit'
          placeholder='Сума'
          value={values.amount}
          onChange={handleChange}
          onBlur={handleBlur}
          errorText={touched.amount && errors.amount}
          invalid={touched.amount && errors.amount}
        />
        <Button type='submit' className={styles.submitBtn} disabled={isSubmitting} noStyle>
          <FontAwesomeIcon icon={faMoneyBillTransfer} />
        </Button>
      </form>
    </div>
  );
};
